import React from 'react';
import useFitText from '../../hooks/useFitText';

/**
 * Renders `children` in `as`, auto-shrinking font-size to keep the block's
 * height within `maxHeight` — so a longer translation occupies the same
 * visual footprint as the original-language copy instead of reflowing the
 * surrounding layout. See useFitText for the fitting algorithm.
 */
export default function FitText({
  as: Tag = 'div',
  maxHeight,
  minFontSize,
  maxFontSize,
  className,
  style,
  children,
  ...rest
}) {
  const ref = useFitText({ maxHeight, minFontSize, maxFontSize, deps: [children] });

  return (
    <Tag ref={ref} className={className} style={{ ...style, fontSize: maxFontSize }} {...rest}>
      {children}
    </Tag>
  );
}
